import INVENTORY_API_BASE_URL from "./config/api";
import { apiFetch } from "./config/apiClient";
import "./App.css";
import { Amplify } from "aws-amplify";
import { fetchAuthSession, signOut } from "aws-amplify/auth";
import awsconfig from "./aws-exports";
import { Authenticator } from "@aws-amplify/ui-react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import Sidebar from "./components/SideBar/Sidebar";
import UserContext from "./components/SideBar/UserContext";
import Createlisting from "./components/CreateListing/Create_listing";
import Managelisting from "./components/ManageListing/Manage_listing";
import SalesReturn from "./components/Dist Sales&Return/SalesRetutn";
import Ordergenerateinstitute from "./components/Institute/Ordergenerateinstitute";
import CoinsCheck from "./components/VishnuPage/CoinsCheck";
import ManageReturnInbound from "./components/Manage ReturnInbound/ManageReturnInbound";
import Mis from "./components/MIS/Mis";
import PurchaseSnapshot from "./components/SnapShow/PurchaseSnap";
import SettlementSnapshot from "./components/SnapShow/SettlementSnap";
import BatchSearch from "./components/ExtraBarcodeShow/extraBarcodes";
import BookSerial from "./components/BookSerial/BookSerial";
import CreatePutaway from "./components/CreatePutaway/CreatePutaway";
import CreateGRN from "./components/CreateGRN/CreateGRN";
import CreateShelf from "./components/CreateShelf/CreateShelf";
import Goodreceivedbatches from "./components/Goodreceived/Goodreceived";
import Manageshelf from "./components/Manageshelf/Manageshelf";
import Booksupplier from "./components/Booksupplier/Booksupplier";
import ApprovePO from "./components/ApprovePO/ApprovePO";
import POcreation from "./components/CreatePO/POcreation";
import POgiven from "./components/POgiven/Pogiven";
import ScanInbound from "./components/ScanInbound/BarcodeReader";
import Purchase from "./components/Purchase/Purchase";
import DistributorPO from "./components/DistributorPO/DistributorPO";
import Managepurchase from "./components/Managepurchase/Managepurchase";
import ApproveDPO from "./components/ApproveDPO/ApproveDPO";
import CreateShipment from "./components/CreateShipment/CreateShipment";
import GeneratedTablePage from "./components/CreateShipment/GeneratedTablePage";
import Createsuperdistributor from "./components/Createsuperdistributor/Createsuperdistributor";
import ManageSuperDist from "./components/ManageSuperDist/ManageSuperDist";
import CreateInvoice from "./components/CreateInvoice/CreateInvoice";
import ManageChallan from "./components/ManageChallan/ManageChallan";
import Managebooksupplier from "./components/Managebooksupplier/Managebooksupplier";
import ManageShipment from "./components/ManageShipment/ManageShipment";
import SerialNumber from "./components/SerialNumber/SerialNumber";
import Manageinbound from "./components/Manageinbound/Manageinbound";
import FlipkartPO from "./components/FlipkartPO/FlipkartPO";
import ManageB2C from "./components/FlipkartPO/ManageB2C";
import Returngrn from "./components/Returngrn/Returngrn";
import Managereturn from "./components/Managereturn/Managereturn";
import FlipkartPOb2c from "./components/B2cearlystage/FlipkartPOb2c";
import ShipmentEarly from "./components/ShipmentEarly/CreateShipment";
import ShipmentEarlyGenerate from "./components/ShipmentEarly/ShipmentEarlyGenerate";
import Manageshipments from "./components/Manageshipments/Manageshipments";
import DistributorAudit from "./components/Distributor Audit/DistributorAudit";
import ReturnLabel from "./components/ReturnLabel/ReturnLabel";
import ReturnInbound from "./components/ReturnInbound/ReturnInbound";
import Findbook from "./components/Findbook/Findbook";
import ManageCreditNote from "./components/ManageCreditNote/ManageCreditNote";
import ReturnInboundList from "./components/Return_ScanPDF/Return_ScanPDF";
import Reorder from "./components/Reorder/Reorder";
import FindShelf from "./components/FindShelf/FindShelf";
import Assets from "./components/Assets/Assets";
import Manageassets from "./components/Manageassets/Manageassets";
import Hologram from "./components/Hologram/Hologram";
import ManageHologram from "./components/ManageHologram/ManageHologram";
import Outbound from "./components/Outbound/Outbound";
import CreatePayment from "./components/CreatePayment/CreatePayment";
import Hashing from "./components/Hash/Hashing";
import Newserial from "./components/Newserial/Newserial";
import Scanhashing from "./components/Scanhashing/Scanhashing";
import B2chashing from "./components/B2chashing/B2chashing";
import Quickhash from "./components/Quickhash/Quickhash";
import CreateShipmentnew from "./components/Createscannew/CreateShipmentnew";
import Generated from "./components/Createscannew/Generated";
import Sticker from "./components/Sticker/Sticker";
import Managescan from "./components/Managescan/Managescan";
import Manageprint from "./components/Manageprinting/Manageprint";
import CreateExtraBarcode from "./components/CreateExtraBarcode/CreateExtraBarcode";
import TransferBarcodes from "./components/TransferData/TransferData";
import ReturnLabel1 from "./components/ReturnlabelNew/ReturnlabelNew";
import ReturnInbound1 from "./components/ReturnInboundNew/RetirninboundNew";
import Orderstatus from "./components/Order/Orderstatus";
import Settlement from "./components/Settlement/Settlement";
import Wrongsticker from "./components/Wrongsticker/Wrongsticker";
import Cancelsticker from "./components/generatecancelsticker/Cancelsticker";
import Rejectedsticker from "./components/Rejectedsticker/Rejectedsticker";
import Purchasequantity from "./components/PurchaseQuantity/Purchasequantity";
import MIsPdf from "./components/MisReport/PDfsho";
import Log from "./components/Log/Log";
import Returnaudit from "./components/Returnaudit/Returnaudit";
import Returnmis from "./components/Returnmis/Returnmis";
import Viewdata from "./components/Viewdata/Viewdata";
import BooklifeCycle from "./components/BookLifeCycle/BooklifeCyle";
import Shelfaudit from "./components/Shelfaudit/Shelfaudit";
import Mentor from "./components/Mentor/Mentor";
import Managementor from "./components/MentorDetail/Managementor";
import Mentorcommission from "./components/Mentorcommission/Mentorcommission";
import ExpenseForm from "./components/Expense/Expense";
import Expensedata from "./components/Expense/Expensedata";
import Createvendor from "./components/Expense/Vendor";
import Vendorlist from "./components/Expense/Vendordata";
import Income from "./components/Expense/Income";
import Incomelist from "./components/Expense/Incomelist";
import Piracy from "./components/Piracy/Piracy";
import Sales from "./components/Sales/Sales";
import ReturnSales from "./components/Return Sales/ReturnSales";
import Sku from "./components/Skuwise/Sku";

Amplify.configure(awsconfig);

function ProtectedRoute({ isAllowed, children }) {
  if (!isAllowed) {
    alert("You are not authorized to access this page.");
    return <Navigate to="/" />;
  }
  return children;
}
function Navbar({ signOutFn, user, isOnline, onlineUsers, currentUser }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef();

  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [data, setData] = useState([]);

  const openModal = async (type) => {
    setModalType(type);
    setModalOpen(true);

    try {
      const url =
        type === "top"
          ? `${INVENTORY_API_BASE_URL}/top-sku-weekly`
          : `${INVENTORY_API_BASE_URL}/least-sku-weekly`;

      const res = await apiFetch(url);
      const result = await res.json();

      setData(result.data || []);
    } catch (err) {
      console.error("ERROR:", err);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const userEmail =
    user?.attributes?.email ||
    user?.signInDetails?.loginId ||
    "Email not found";

  return (
    <>
      <nav className="inventory-topbar" aria-label="Main navigation">
        <div className="inventory-topbar__primary">
          <span className="inventory-topbar__brand">Pinnacle Inventory</span>
          <button
            className="inventory-topbar__action inventory-topbar__action--top"
            type="button"
            onClick={() => openModal("top")}
          >
            Top SKU Sales
          </button>
          <button
            className="inventory-topbar__action inventory-topbar__action--least"
            type="button"
            onClick={() => openModal("least")}
          >
            Least SKU Sales
          </button>
        </div>

        <div className="inventory-topbar__account">
          <p className="inventory-topbar__user" title={userEmail}>
            Logged in as: <strong className="inventory-topbar__user-email">{userEmail}</strong>
          </p>
          <button
            className="inventory-topbar__signout"
            type="button"
            onClick={async () => {
              try {
                const email =
                  user?.attributes?.email || user?.signInDetails?.loginId;
                const name = email?.split("@")[0];

                await apiFetch(
                  `${INVENTORY_API_BASE_URL}/api/user/online-status`,
                  {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email, name, isOnline: false }),
                  },
                );

                await signOutFn();
              } catch (err) {
                console.error(err);
                await signOutFn();
              }
            }}
          >
            Sign Out
          </button>
        </div>
      </nav>

      {modalOpen && (
        <div
          onClick={() => setModalOpen(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            backdropFilter: "blur(4px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#ffffff",
              padding: "20px",
              borderRadius: "12px",
              width: "420px",
              maxHeight: "500px",
              overflowY: "auto",
              boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
              animation: "fadeIn 0.3s ease",
            }}
          >
            {data.length === 0 ? (
              <p style={{ textAlign: "center", color: "#888" }}>
                No data found
              </p>
            ) : (
              data.map((item, index) => (
                <div
                  key={index}
                  style={{
                    padding: "10px",
                    borderBottom: "1px solid #eee",
                    borderRadius: "6px",
                    marginBottom: "8px",
                    background: "#f9f9f9",
                    transition: "0.2s",
                  }}
                >
                  <div style={{ fontWeight: "600", color: "#444" }}>
                    #{index + 1} — {item.sku}
                  </div>

                  <div style={{ fontSize: "13px", color: "#666" }}>
                    {item.title || "N/A"}
                  </div>

                  <div
                    style={{
                      marginTop: "5px",
                      fontWeight: "bold",
                      color: "#007bff",
                    }}
                  >
                    Sold : {item.totalSold}
                  </div>
                </div>
              ))
            )}

            <button
              onClick={() => setModalOpen(false)}
              style={{
                marginTop: "15px",
                width: "100%",
                padding: "8px",
                border: "none",
                borderRadius: "6px",
                background: "linear-gradient(135deg, #ff6a00, #ee0979)",
                color: "#fff",
                fontWeight: "bold",
                cursor: "pointer",
                transition: "0.3s",
              }}
              onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
              onMouseLeave={(e) => (e.target.style.opacity = "1")}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
function App() {
  const [userGroup, setUserGroup] = useState(null);
  const [checkingAuth, setCheckingAuth] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);

  const [isOnline, setIsOnline] = useState(false);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const updateOnlineStatus = async () => {
      try {
        const email = user?.attributes?.email || user?.signInDetails?.loginId;
        const name = email?.split("@")[0];
        if (!email) return;

        await apiFetch(`${INVENTORY_API_BASE_URL}/api/user/online-status`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, name, isOnline: true }),
        });
      } catch (err) {
        console.error("❌ Error setting isOnline true after login", err);
      }
    };

    if (user) {
      updateOnlineStatus();
    }
  }, [user]);

  useEffect(() => {
    if (!user) {
      setOnlineUsers([]);
      return undefined;
    }

    const fetchOnlineUsers = async () => {
      try {
        const res = await apiFetch(
          `${INVENTORY_API_BASE_URL}/api/online-users`,
        );
        const data = await res.json();
        setOnlineUsers(data);
      } catch (error) {
        console.error("❌ Error fetching online users:", error);
      }
    };

    fetchOnlineUsers();
    const interval = setInterval(fetchOnlineUsers, 10000);
    return () => clearInterval(interval);
  }, [user]);

  useEffect(() => {
    const checkUserGroup = async () => {
      try {
        const session = await fetchAuthSession({ forceRefresh: true });
        const groups = session.tokens?.idToken?.payload["cognito:groups"] || [];

        const lowerCaseGroups = groups.map((g) => g.toLowerCase());

        if (lowerCaseGroups.includes("admin")) {
          setUserGroup("admin");
        } else if (lowerCaseGroups.includes("warehouse")) {
          setUserGroup("warehouse");
        } else {
          alert("Access denied. You are not authorized.");
          await signOut();
        }
      } catch (error) {
        console.error("Error during group check:", error);
        await signOut();
      } finally {
        setCheckingAuth(false);
      }
    };

    if (currentUser) {
      checkUserGroup();
    }
  }, [currentUser]);

  useEffect(() => {
    if (user) {
      setCurrentUser(user);
    }
  }, [user]);

  return (
    <Authenticator>
      {({ signOut: amplifySignOut, user }) => {
        if (!currentUser && user) {
          setCurrentUser(user);
          setUser(user);
        }

        if (checkingAuth || !userGroup) {
          return null;
        }

        const isAdmin = userGroup === "admin";
        const isWarehouse = userGroup === "warehouse";

        return (
          <BrowserRouter>
            <UserContext.Provider value={{ user }}>
              <div className="App">
                <Navbar
                  signOutFn={amplifySignOut}
                  user={user}
                  isOnline={isOnline}
                  onlineUsers={onlineUsers}
                  currentUser={currentUser}
                />

                <Sidebar userGroup={userGroup} />
                <Routes>
                  <Route path="Log" element={<Log />} />

                  <Route
                    path="Managelisting"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Managelisting />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Sales"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Sales />
                      </ProtectedRoute>
                    }
                  />



                  <Route
                    path="/"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Sku />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Ordergenerateinstitute"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Ordergenerateinstitute />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Createlisting"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Createlisting />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Piracy"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Piracy />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ExpenseForm"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <ExpenseForm />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Expensedata"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Expensedata />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Createvendor"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Createvendor />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Vendorlist"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Vendorlist />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Income"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Income />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Incomelist"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Incomelist />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Viewdata"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Viewdata />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Mentorcommission"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Mentorcommission />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Reorder"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Reorder />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Managementor"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Managementor />
                      </ProtectedRoute>
                    }
                  />


                  <Route
                    path="Shelfaudit"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Shelfaudit />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ManageReturnInbound"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <ManageReturnInbound />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Mentor"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Mentor />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Returnaudit"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Returnaudit />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Goodreceivedbatches"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Goodreceivedbatches />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Settlement"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Settlement />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Manageprint"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Manageprint />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Manageshelf"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Manageshelf />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="BookSerial"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <BookSerial />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="CreatePutaway"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <CreatePutaway />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ScanInbound"
                    element={
                      <ProtectedRoute isAllowed={isAdmin || isWarehouse}>
                        <ScanInbound />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="CreateGRN"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <CreateGRN />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="CreateShelf"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <CreateShelf />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Booksupplier"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Booksupplier />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ApprovePO"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <ApprovePO />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="POcreation"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <POcreation />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="POgiven"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <POgiven />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Purchase"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Purchase />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="DistributorPO"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <DistributorPO />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Managepurchase"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Managepurchase />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ApproveDPO"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <ApproveDPO />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Mis"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Mis />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/return-mis"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Returnmis />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="CreateShipment"
                    element={
                      <ProtectedRoute isAllowed={isAdmin || isWarehouse}>
                        <CreateShipment />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="TransferBarcodes"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <TransferBarcodes />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Createsuperdistributor"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Createsuperdistributor />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/GeneratedTablePage/:numRows"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <GeneratedTablePage />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="CreateShipmentnew"
                    element={
                      <ProtectedRoute isAllowed={isAdmin || isWarehouse}>
                        <CreateShipmentnew />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/Generated/:numRows"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Generated />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Quickhash"
                    element={
                      <ProtectedRoute isAllowed={isAdmin || isWarehouse}>
                        <Quickhash />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="B2chashing"
                    element={
                      <ProtectedRoute isAllowed={isAdmin || isWarehouse}>
                        <B2chashing />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Scanhashing"
                    element={
                      <ProtectedRoute isAllowed={isAdmin || isWarehouse}>
                        <Scanhashing />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Hashing"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Hashing />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ManageSuperDist"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <ManageSuperDist />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="CreateInvoice"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <CreateInvoice />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ManageChallan"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <ManageChallan />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Managebooksupplier"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Managebooksupplier />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Managescan"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Managescan />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Sticker"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Sticker />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ManageShipment"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <ManageShipment />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="SerialNumber"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <SerialNumber />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Manageinbound"
                    element={
                      <ProtectedRoute isAllowed={isAdmin || isWarehouse}>
                        <Manageinbound />
                      </ProtectedRoute>
                    }
                  />


                  <Route
                    path="FlipkartPO"
                    element={
                      <ProtectedRoute isAllowed={isAdmin || isWarehouse}>
                        <FlipkartPO />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ManageB2C"
                    element={
                      <ProtectedRoute isAllowed={isAdmin || isWarehouse}>
                        <ManageB2C />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Returngrn"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Returngrn />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Managereturn"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Managereturn />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="FlipkartPOb2c"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <FlipkartPOb2c />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ShipmentEarly"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <ShipmentEarly />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Manageshipments"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Manageshipments />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/ShipmentEarlyGenerate/:numRows"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <ShipmentEarlyGenerate />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/mis-pdf"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <MIsPdf />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Orderstatus"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Orderstatus />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Newserial"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Newserial />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="DistributorAudit"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <DistributorAudit />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ReturnLabel"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <ReturnLabel />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ReturnInbound"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <ReturnInbound />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Findbook"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Findbook />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ManageCreditNote"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <ManageCreditNote />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="FindShelf"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <FindShelf />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Assets"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Assets />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Manageassets"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Manageassets />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="SalesReturn"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <SalesReturn />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Hologram"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Hologram />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ManageHologram"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <ManageHologram />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Outbound"
                    element={
                      <ProtectedRoute isAllowed={isAdmin || isWarehouse}>
                        <Outbound />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="CreatePayment"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <CreatePayment />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ReturnLabel1"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <ReturnLabel1 />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ReturnInbound1"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <ReturnInbound1 />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Wrongsticker"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Wrongsticker />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Cancelsticker"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Cancelsticker />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Rejectedsticker"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Rejectedsticker />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="Purchasequantity"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <Purchasequantity />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="PurchaseSnapshot"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <PurchaseSnapshot />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="SettlementSnapshot"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <SettlementSnapshot />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="CreateExtraBarcode"
                    element={
                      <ProtectedRoute isAllowed={isAdmin}>
                        <CreateExtraBarcode />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="ReturnInboundList"
                    element={<ReturnInboundList />}
                  />
                  <Route path="BatchSearch" element={<BatchSearch />} />
                  <Route path="BooklifeCycle" element={<BooklifeCycle />} />
                  <Route path="CoinsCheck" element={<CoinsCheck />} />
                  <Route path="ReturnSales" element={<ReturnSales />} />

                  <Route path="*" element={<Navigate to="/" />} />
                </Routes>
              </div>
            </UserContext.Provider>
          </BrowserRouter>
        );
      }}
    </Authenticator>
  );
}

export default App;
